module.exports = __webpack_public_path__ + "static/img/rank_222.094b30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_222.png
// module id = b6+Y
// module chunks = 1